import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getRole (success, error) {
    Vue.axios.get(URL + 'role').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UserAll (obj, header, success, error) {
    Vue.axios.post(URL + 'user/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addUser (obj, header, success, error) {
    Vue.axios.post(URL + 'user', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UserUpdate (obj, header, success, error) {
    Vue.axios.put(URL + 'user', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteUser (id, header, success, error) {
    Vue.axios.delete(URL + 'user/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getUserDetail (header, success, error) {
    Vue.axios.get(URL + 'user', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_user.js